(() => {
  const scenes = [...document.querySelectorAll('[data-svrn-motion]')];
  if (!scenes.length) return;
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const destinations = {
    gummies: [
      [-.39, -.30, -32, .92], [.40, -.34, 24, .7], [-.43, .06, 20, .64],
      [.41, .08, -29, .9], [-.20, .43, -15, .74], [.21, .43, 35, .58], [.02, -.47, -8, .52],
    ],
    rize: [
      [-.42, -.29, -48, .9], [.38, -.38, 36, .7], [-.43, .10, 24, .65],
      [.43, .08, -34, .95], [-.21, .41, -53, .7], [.24, .42, 41, .66], [.03, -.45, 21, .5],
    ],
  };
  const clamp = (value) => Math.max(0, Math.min(1, value));
  const smooth = (value) => value * value * (3 - 2 * value);
  const items = scenes.map((section) => ({
    section,
    sticky: section.querySelector('.svrn-motion__sticky'),
    stage: section.querySelector('.svrn-motion__stage'),
    object: section.querySelector('[data-motion-object]'),
    closed: section.querySelector('[data-motion-closed]'),
    lid: section.querySelector('[data-motion-lid]'),
    state: section.querySelector('[data-motion-state]'),
    toggle: section.querySelector('[data-motion-toggle]'),
    format: section.dataset.motionFormat,
    track: section.querySelector('[data-motion-track]'),
    pieces: [...section.querySelectorAll('[data-svrn-piece]')],
    destinations: destinations[section.dataset.motionFormat] || destinations.gummies,
    current: -1,
    manualProgress: null,
  }));
  let frame = 0;

  function render() {
    frame = 0;
    let moving = false;
    for (const item of items) {
      const rect = item.section.getBoundingClientRect();
      if (rect.bottom < -150 || rect.top > innerHeight + 150) continue;
      const travel = Math.max(1, rect.height - item.sticky.clientHeight);
      const stickyTop = Number.parseFloat(getComputedStyle(item.sticky).top) || 0;
      const scrollProgress = clamp((stickyTop - rect.top) / travel);
      const target = item.manualProgress ?? (reducedMotion ? 0 : scrollProgress);
      item.current = reducedMotion || item.current < 0 ? target : item.current + (target - item.current) * .18;
      if (Math.abs(target - item.current) > .001) moving = true;
      const progress = item.current;
      const stageWidth = item.stage.clientWidth;
      const stageHeight = item.stage.clientHeight;
      const opening = smooth(clamp((progress - .08) / .38));
      const opened = smooth(clamp((progress - .12) / .24));
      const objectSize = item.object.clientWidth;
      const objectTurn = item.format === 'gummies' ? -5 + progress * 9 : -4 + progress * 8;
      item.object.style.transform = `translate3d(-50%,calc(-50% + ${(1 - progress) * 22}px),0) rotateY(${objectTurn.toFixed(1)}deg) scale(${(.94 + .065 * smooth(progress)).toFixed(3)})`;
      item.closed.style.opacity = (1 - opened).toFixed(3);
      if (item.format === 'gummies') {
        item.lid.style.transform = `translate3d(0,${(-opening * 9).toFixed(1)}px,${(opening * 80).toFixed(1)}px) rotateX(${(-opening * 78).toFixed(1)}deg)`;
        item.lid.style.opacity = String(1 - smooth(clamp((progress - .40) / .25)));
      } else {
        item.lid.style.transform = `translate3d(${(opening * 42).toFixed(1)}px,${(-opening * objectSize * .22).toFixed(1)}px,${(opening * 115).toFixed(1)}px) rotateY(${(opening * 32).toFixed(1)}deg) rotateZ(${(opening * 16).toFixed(1)}deg)`;
        item.lid.style.opacity = String(smooth(clamp((progress - .08) / .22)));
      }
      item.state.textContent = progress < .1 ? 'SCROLL OR TAP TO OPEN' : progress < .52 ? 'OPENING THE PACK' : 'EXPLORE THE FORMAT';
      item.track.style.transform = `scaleX(${progress.toFixed(4)})`;
      item.pieces.forEach((piece, index) => {
        const [destX, destY, turn, finalScale] = item.destinations[index];
        const entered = clamp((progress - .34 - index * .024) / .43);
        const drift = smooth(entered);
        const startX = item.format === 'rize' ? objectSize * .23 : 0;
        const startY = item.format === 'rize' ? -objectSize * .24 : -objectSize * .34;
        const x = startX + (destX * stageWidth - startX) * drift;
        const y = startY + (destY * stageHeight - startY) * drift;
        const scale = .18 + (finalScale - .18) * drift;
        piece.style.opacity = String(clamp(entered * 2.7));
        piece.style.transform = `translate3d(calc(-50% + ${x.toFixed(1)}px),calc(-50% + ${y.toFixed(1)}px),${(drift * 90).toFixed(1)}px) rotateY(${(drift * (index % 2 ? -42 : 38)).toFixed(1)}deg) rotateZ(${(turn * drift).toFixed(1)}deg) scale(${scale.toFixed(3)})`;
      });
    }
    if (moving) frame = requestAnimationFrame(render);
  }
  const queue = () => { if (!frame) frame = requestAnimationFrame(render); };
  items.forEach((item) => {
    item.toggle?.addEventListener('click', () => {
      const open = item.manualProgress !== 1;
      item.manualProgress = open ? 1 : 0;
      item.section.classList.toggle('is-open', open);
      item.toggle.setAttribute('aria-pressed', String(open));
      item.toggle.firstChild.textContent = open ? 'Close the pack ' : `Open the ${item.format === 'rize' ? 'bottle' : 'pouch'} `;
      queue();
    });
  });
  addEventListener('scroll', queue, { passive: true });
  addEventListener('resize', queue, { passive: true });
  addEventListener('load', queue, { once: true });
  queue();
})();
